import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EventBookerRenderer } from 'payroll/components/CellRenderers';

const useEventBookerColumn = ({ mappedAdmins }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback(
    (params) => {
      if (params.node?.group) {
        return null;
      }
      const { firstName, lastName } = mappedAdmins?.[params.data?.bookerId] || {};
      return [firstName, lastName].filter(Boolean).join(' ');
    },
    [mappedAdmins]
  );

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return EventBookerRenderer({
        rowData: params.data,
        columnData: { mappedAdmins }
      });
    },
    [mappedAdmins]
  );

  return useMemo(
    () => ({
      field: 'eventBooker',
      headerName: t('eventBooker'),
      width: 120,
      initialHide: true,
      cellClass: 'justify-start',
      valueGetter,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer]
  );
};

export default useEventBookerColumn;
